import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './TopBanner.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var TopBanner = function TopBanner() {
  return /*#__PURE__*/_jsx("div", {
    className: styles['wrapper'],
    children: /*#__PURE__*/_jsx(UIText2, {
      children: "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0441\u0441\u044B\u043B\u043A\u0443 \u043D\u0430 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u0438 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \xAB\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C\xBB"
    })
  });
};